import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setAdvancedSearch } from '../../redux/slices/Search/input'
import SimpleSearch from '../SimpleSearch'
import AdvancedSearch from '../AdvancedSearch'
import StyledPopoverContainer from './StyledPopoverContainer'

const PopoverSearch = ({ id, open, position, anchorEl, onClose, isAuth = false }) => {
  const dispatch = useDispatch()
  const { advancedSearch, advancedSearchUsed, basicList, filtersList } = useSelector(
    state => state.filterSearch
  )

  // Sincroniza el modo de búsqueda avanzada al abrir
  useEffect(() => {
    if (!open) return
    if (advancedSearch !== advancedSearchUsed)
      dispatch(setAdvancedSearch(advancedSearchUsed))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  return (
    <StyledPopoverContainer
      id={id}
      open={open}
      anchorEl={anchorEl}
      position={position}
      onClose={onClose}>
      {({ windowWidth }) =>
        !advancedSearch ? (
          <SimpleSearch
            open={open}
            windowWidth={windowWidth}
            basicList={basicList}
            isAuth={isAuth}
          />
        ) : (
          <AdvancedSearch
            open={open}
            windowWidth={windowWidth}
            advancedSearchUsed={advancedSearchUsed}
            filtersList={filtersList}
          />
        )
      }
    </StyledPopoverContainer>
  )
}

export default PopoverSearch
